import type { PreviewIntegration } from '@/modules/Workspaces/KnowledgeHub/Integrations/integrationTypes'
import SalesforceLogo from './SalesforceLogo.vue'

export const salesforceIntegration: PreviewIntegration = {
  id: 'salesforce',
  name: 'Salesforce',
  description:
    'Integrate your customer relationship data from Salesforce to give your AI comprehensive business context.',
  icon: SalesforceLogo,
}
